import { render, staticRenderFns } from "./CreateBranch.vue?vue&type=template&id=52ca8940&scoped=true&"
import script from "./CreateBranch.vue?vue&type=script&lang=js&"
export * from "./CreateBranch.vue?vue&type=script&lang=js&"
import style0 from "./CreateBranch.vue?vue&type=style&index=0&id=52ca8940&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ca8940",
  null
  
)

export default component.exports